<div mat-dialog-title *ngIf="dialogTitle || dialogTitle2">
  <div class="header" [class.header-primary]="isPrimary">
    <div *ngIf="!dialogTitle2; else doubleColumn" class="title">{{ dialogTitle }}</div>

    <div *ngIf="!isPrimary" class="divider"></div>

    <div class="close-button">
      <a (click)="onCancel()"><app-svg-icon class="x-icon" src="./assets/icons/close-icon.svg"></app-svg-icon></a>
    </div>
  </div>
</div>

<div mat-dialog-content>
  <ng-content select="[dialog-content]"></ng-content>

  <div *ngIf="!dialogTitle && !dialogTitle2" class="close-button">
    <a (click)="onCancel()"><app-svg-icon class="x-icon" src="./assets/icons/close-icon.svg"></app-svg-icon></a>
  </div>
</div>

<div mat-dialog-actions>
  <ng-content select="[dialog-actions]"></ng-content>
</div>

<ng-template #doubleColumn>
  <div class="doubleColumn">
    <div class="first title">{{ dialogTitle }}</div>
    <div class="second title">{{ dialogTitle2 }}</div>
  </div>
</ng-template>
